'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _endpoints = require('./endpoints');var _endpoints2 = _interopRequireDefault(_endpoints);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var api = new _endpoints2.default();exports.default =

api;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcGkvYXBpLmpzIl0sIm5hbWVzIjpbImFwaSIsImVuZHBvaW50cyJdLCJtYXBwaW5ncyI6IjJFQUFBLHdDOztBQUVBLElBQU1BLE1BQU0sSUFBSUMsbUJBQUosRUFBWixDOztBQUVlRCxHIiwiZmlsZSI6ImFwaS5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGVuZHBvaW50cyBmcm9tICcuL2VuZHBvaW50cydcblxuY29uc3QgYXBpID0gbmV3IGVuZHBvaW50cygpXG5cbmV4cG9ydCBkZWZhdWx0IGFwaVxuIl19


//////////////////
// WEBPACK FOOTER
// ./src/api/api.js
// module id = P9l9
// module chunks = 7